import React from 'react';
import ReactDOM from 'react-dom/client';
import { BowsPage } from './BowsPage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { initMonitoring } from '@/lib/monitoring';
import '../../index.css';
import './profiles.css';

initMonitoring('bows');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="My Bows">
      <BowsPage />
    </SafeBoundary>
  </React.StrictMode>
);
